<template>
  <v-menu
    v-if="item.label || item.value"
    :activator="activator"
    allow-overflow
    origin="center center"
    :offset-x="location.left || location.right"
    :offset-y="location.top || location.bottom"
    :bottom="location.bottom"
    :left="location.left"
    :right="location.right"
    :top="location.top"
    content-class="elevation-0 overflow-visible"
    :value="value"
    @input="$emit('input', $event)"
  >
    <div class="doughnut-resume">
      <div
        v-if="item.label "
        class="doughnut-resume__label texte texte-gris-fonce"
      >
        {{ item.label }}
      </div>
      <div
        v-if="item.value"
        class="doughnut-resume__value"
      >
        {{ item.value | roundNumber(precision) | splitNumber }} {{ item.unit }}
      </div>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: 'DoughnutResume',

  props: {
    activator: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
      required: true
    },
    percentage: {
      type: Number,
      default: 0
    },
    radius: {
      type: Number,
      default: 0
    }
  },

  emits: ['input'],

  data () {
    return {
      location: {
        top: false,
        bottom: false,
        left: false,
        right: false
      }
    }
  },

  computed: {
    precision () {
      return this.item.precision != null ? this.item.precision : 2
    }
  },

  watch: {
    percentage: {
      handler () {
        let percentage = this.percentage
        if (percentage < 0) {
          percentage = 100 + percentage
        }
        const anglePercentage = (360 * percentage) / 100
        const trigoAngle = -(anglePercentage * Math.PI / 180) + Math.PI / 2

        const x = Math.cos(trigoAngle)
        const y = Math.sin(trigoAngle)

        this.location = {
          top: false,
          bottom: false,
          left: false,
          right: false
        }
        if (x <= 0) {
          this.location.left = true
        } else {
          this.location.right = true
        }

        if (y >= 0) {
          this.location.top = true
        } else {
          this.location.bottom = true
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.doughnut-resume {
  margin: 3px;
  padding: 16px;
  border-radius: 12px;
  background-color: #ffffff;
  filter: drop-shadow(
      0px 3px 1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2))
    )
    drop-shadow(
      0px 2px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14))
    )
    drop-shadow(
      0px 1px 3px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12))
    );

  .doughnut-resume__value {
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 1.6;
    color: var(--v-primary-base);
  }
}
</style>
